import { z } from 'zod';
import { AccountStatus, LeadStatus } from '../enums.js';
/** /api/admin/dashboard — one-shot aggregate for the operator landing page. */
export const DashboardOverview = z.object({
    accounts: z.object({
        total: z.number().int(),
        /** Currently spawned by TgRuntime (in-memory map size). */
        connected: z.number().int(),
        byStatus: z.record(AccountStatus, z.number().int()),
        /** observer vs sender breakdown (Phase 8 strict split). */
        byPurpose: z.object({
            observer: z.number().int(),
            sender: z.number().int(),
        }),
    }),
    groups: z.object({
        total: z.number().int(),
        active: z.number().int(),
    }),
    ingest: z.object({
        rawMessagesLast1h: z.number().int(),
        rawMessagesLast24h: z.number().int(),
        rawMessagesTotal: z.number().int(),
        /** Redis XLEN on the raw_messages stream (events still in buffer). */
        streamLength: z.number().int(),
        /** XPENDING summary count — events fetched but not yet ack'd. */
        streamPending: z.number().int(),
    }),
    leads: z.object({
        total: z.number().int(),
        today: z.number().int(),
        last24h: z.number().int(),
        byStatus: z.record(LeadStatus, z.number().int()),
    }),
    llm: z.object({
        today: z.object({
            calls: z.number().int(),
            totalTokens: z.number().int(),
            costUsd: z.number(),
        }),
        last24h: z.object({
            calls: z.number().int(),
            totalTokens: z.number().int(),
            costUsd: z.number(),
        }),
    }),
    outbound: z.object({
        /** Leads waiting in the outbound queue (status='queued'). */
        queued: z.number().int(),
        /** Leads currently in-flight DM cycle (status='contacted'/'awaiting_reply'). */
        inFlight: z.number().int(),
        /** Leads with at least one inbound reply (status='replied'). */
        replied: z.number().int(),
        /** Outbound DMs sent in the last 24h (Message direction='out', sentBy='system'). */
        sentLast24h: z.number().int(),
        /** Replies received in the last 24h (Message direction='in'). */
        repliesLast24h: z.number().int(),
        /** Reply-rate over last 24h, 0-1. */
        replyRate24h: z.number(),
    }),
    serverNow: z.string().datetime(),
});
//# sourceMappingURL=dashboard.js.map